/**
 * Designer AutoSource / AutoCondition options.
 *
 * AutoSource — fills template value '#' from lesson/project context (CONTENT, NOTES,
 * SLIDENO, SLIDEON/CN, LESSONON/CN, PROJECTPARAM, …).
 *
 * AutoCondition — if set and false, the line is NOT inserted into projectslidelines at all.
 * See Backend materializeProjectSlideLines.passesCondition for evaluation rules.
 */
export const LINE_AUTO_SOURCES: string[] = [
  'CONTENT',
  'ICONTENT',
  'NOTES',
  'SLIDEON',
  'SLIDECN',
  'SLIDENO',
  'LESSONON',
  'LESSONCN',
  'SLIDETITLE',
  'LESSONTITLE',
  'PROJECTPARAM',
];

export const LINE_AUTO_CONDITIONS: string[] = [
  // Insert only when project SlideSrNo is odd / even (trainer image / voice alternation by slide)
  'SLNOODD',
  'SLNOEVEN',
  // Insert only when object-group instance index is odd / even
  'GRPNODD',
  'GRPNOEVEN',
  // Legacy aliases of GRPNODD / GRPNOEVEN
  'ISODD',
  'ISEVEN',
  // Compare group instance SrNo to AutoVal
  'GT',
  'LT',
  'EQ',
  // Lesson element type / indent (AutoVal = indent level for ISINDENT)
  'ISIMAGE',
  'ISTEXT',
  'ISAUDIO',
  'ISVIDEO',
  'ISINDENT',
];
